import { useEffect, useState } from "react";
import { cn } from "@/lib/utils";

interface AnnouncementBarProps {
  messages: string[];
  interval?: number;
}

export const AnnouncementBar = ({ messages, interval = 4000 }: AnnouncementBarProps) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (messages.length <= 1) return;

    const timer = setInterval(() => {
      // Fade out
      setIsVisible(false);
      
      // After fade out, change message and fade in
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % messages.length);
        setIsVisible(true);
      }, 300);
    }, interval);

    return () => clearInterval(timer);
  }, [messages.length, interval]);

  if (!messages.length) return null;

  return (
    <div className="bg-primary text-primary-foreground py-2.5 overflow-hidden">
      <div className="max-w-[1600px] mx-auto px-4 flex items-center justify-center">
        <div className="relative h-5 flex items-center justify-center overflow-hidden">
          <span 
            className={cn(
              "text-sm font-medium text-center transition-all duration-300 ease-in-out",
              isVisible 
                ? "opacity-100 translate-y-0" 
                : "opacity-0 -translate-y-2"
            )}
          >
            {messages[currentIndex]}
          </span>
        </div>
        
        {/* Dots indicator */}
        {messages.length > 1 && (
          <div className="flex items-center gap-1.5 ml-4">
            {messages.map((_, index) => (
              <button
                key={index}
                onClick={() => {
                  setIsVisible(false);
                  setTimeout(() => {
                    setCurrentIndex(index);
                    setIsVisible(true);
                  }, 300);
                }}
                className={cn(
                  "w-1.5 h-1.5 rounded-full transition-all duration-300",
                  index === currentIndex 
                    ? "bg-primary-foreground w-4" 
                    : "bg-primary-foreground/40 hover:bg-primary-foreground/60"
                )}
                aria-label={`Správa ${index + 1}`}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
